export default __webpack_public_path__ + "static/media/speed.ee361b41.svg";